import { Loader } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuthCompat } from "../hooks/useAuthCompat";

export const Route = createFileRoute("/signin")({
	component: SignInRedirect,
});

function SignInRedirect() {
	const { user, isLoading, signIn } = useAuthCompat();

	useEffect(() => {
		if (isLoading) return;
		if (user) {
			window.location.href = "/";
			return;
		}
		signIn();
	}, [user, isLoading, signIn]);

	return (
		<div className="flex items-center justify-center min-h-screen">
			<Loader size="lg" />
		</div>
	);
}
